import { createListHeaders } from '../../utils/createListHeaders';

export const headers = createListHeaders({
  statusKey: 'pensioner_status',
  nameFieldsType: 'pensioner'
});
